export const __rowId__ = "__rowId__";
export const __toggled__ = "__toggled__";
export const __none__ = "__none__";


// WEBPACK FOOTER //
// ./src/components/util/constants.js